import type {UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import type {CourseAttrs} from '@freckle/educator-entities/ts/roster/models/course'
import {
  fetchCourses,
  fetchCoursesWithSubject
} from '@freckle/educator-entities/ts/roster/models/course'
import type {SubjectT} from '../helpers/subjects'

export const QUERY_KEY = 'fetchCourses'

export function useCourses(
  options?: Partial<UseQueryOptions<CourseAttrs[]>>
): UseQueryResult<CourseAttrs[]> {
  const defaultOptions = {staleTime: 60 * 1000}
  return useAsync(fetchCourses, QUERY_KEY, [], {...defaultOptions, ...options})
}

const SUBJECT_QUERY_KEY = 'fetchCoursesWithSubject'

export const useCoursesWithSubject = (subject: SubjectT): UseQueryResult<CourseAttrs[]> =>
  useAsync(() => fetchCoursesWithSubject(subject), SUBJECT_QUERY_KEY, [subject], {
    staleTime: 60000
  })
